<template>
  <div class="bg-gray-100">
    <div class="container mx-auto px-6 pt-16 pb-10 text-center">
      <h1 class="font-serif text-2xl md:text-3xl text-gray-900 mb-3">{{ $t('transparency.title') }}</h1>
      <p class="text-gray-500">{{ $t('transparency.subtitle') }}</p>
      <div class="w-16 h-px bg-gray-300 mx-auto mt-6"></div>
    </div>

    <!-- Main Content -->
    <main class="container mx-auto max-w-3xl p-6 pb-16">
      <section class="bg-white shadow-md rounded-lg p-8 mb-8">
        <h2 class="font-serif text-xl text-gray-900 mb-5">{{ $t('transparency.registry.title') }}</h2>
        <dl class="text-sm divide-y divide-gray-100">
          <div class="py-2.5 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-500">{{ $t('transparency.registry.denomination') }}</dt>
            <dd class="sm:col-span-2 text-gray-900">Associazione TAU APS</dd>
          </div>
          <div class="py-2.5 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-500">{{ $t('transparency.registry.fiscal-code') }}</dt>
            <dd class="sm:col-span-2 text-gray-900">92236610926</dd>
          </div>
          <div class="py-2.5 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-500">{{ $t('transparency.registry.runts') }}</dt>
            <dd class="sm:col-span-2 text-gray-900">{{ $t('transparency.registry.runts-value') }}</dd>
          </div>
          <div class="py-2.5 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-500">{{ $t('transparency.registry.legal-address') }}</dt>
            <dd class="sm:col-span-2 text-gray-900">{{ $t('transparency.registry.legal-address-value') }}</dd>
          </div>
          <div class="py-2.5 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-500">{{ $t('transparency.registry.email') }}</dt>
            <dd class="sm:col-span-2">
              <a href="mailto:associazionetau@virgilio.it"
                class="text-gray-900 underline decoration-gray-300 underline-offset-2 hover:decoration-gray-900">associazionetau@virgilio.it</a>
            </dd>
          </div>
          <div class="py-2.5 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-500">{{ $t('transparency.registry.pec') }}</dt>
            <dd class="sm:col-span-2">
              <a href="mailto:associazionetau@pec.it"
                class="text-gray-900 underline decoration-gray-300 underline-offset-2 hover:decoration-gray-900">associazionetau@pec.it</a>
            </dd>
          </div>
        </dl>
      </section>

      <section class="bg-white shadow-md rounded-lg p-8 mb-8">
        <h2 class="font-serif text-xl text-gray-900 mb-5">{{ $t('transparency.funding.title') }}</h2>
        <i18n-t keypath="transparency.funding.text" tag="p" class="text-sm leading-6 text-gray-700" scope="global">
          <template v-slot:amount>
            <strong>€ 4.000,00</strong>
          </template>
          <template v-slot:project>
            <strong>{{ $t('transparency.funding.project-name') }}</strong>
          </template>
        </i18n-t>
      </section>

      <section class="bg-white shadow-md rounded-lg p-8 mb-8">
        <h2 class="font-serif text-xl text-gray-900 mb-5">{{ $t('transparency.anac.title') }}</h2>
        <h3 class="font-semibold text-sm text-gray-900 mb-2">{{ $t('transparency.anac.subtitle') }}</h3>
        <p class="text-sm leading-6 text-gray-700 mb-4">{{ $t('transparency.anac.text') }}</p>
        <p class="text-sm leading-6 text-gray-700 mb-4">{{ $t('transparency.anac.response-intro') }}</p>
        <div class="flex flex-col sm:flex-row gap-3">
          <a href="/documents/nota-anac.pdf" target="_blank"
            class="flex items-center gap-2 text-sm border border-gray-200 rounded-lg px-4 py-3 hover:border-gray-400 hover:bg-gray-50 transition-colors">
            <Icon name="mdi:file-pdf-box" class="shrink-0 text-gray-500" />
            {{ $t('transparency.anac.nota-pdf') }}
          </a>
          <a href="/documents/risposte-questionario-anac.pdf" target="_blank"
            class="flex items-center gap-2 text-sm border border-gray-200 rounded-lg px-4 py-3 hover:border-gray-400 hover:bg-gray-50 transition-colors">
            <Icon name="mdi:file-pdf-box" class="shrink-0 text-gray-500" />
            {{ $t('transparency.anac.risposte-pdf') }}
          </a>
        </div>
      </section>
    </main>
  </div>
</template>

<script lang="ts" setup>

</script>

<style>
</style>
